if (typeof jQuery === 'undefined') {
    throw new Error("ABWeb Modal Error: jQuery must be loaded before this plugin can be run.");
}

(function($) {
    "use strict";

    if ($ === false) {
        return false;
    }

    var viewport = $(document).find('body'),
        overlay = $(document).find('#overlay'),
        _default = {
            animation: true,
            backdrop: true,
            keyboard: true
        },
        options = {};

    $.fn.abwebModal = function (settings, params, extra)
    {
        var target, orig_target, content;

        // Simple modal support - allows settings to be text
        if (typeof this === 'function') {
            content = settings;
            settings = params;
            params = extra;

            var modal = $('<div class="abweb-modal hide"><div class="abweb-modal-header">Message</div><div class="abweb-modal-body">' + content + '</div></div>');
            $('body').append(modal);
            target = modal;
            $(modal).data('modal', modal);
        } else if (typeof settings !== 'string') {
            // Grab content of this modal
            var modal_content = $('<div class="abweb-modal hide"></div>');
            $(this).data('parent', $(this).parent());
            $(this).addClass('hide');
            $(this).detach();
            $(this).appendTo('body');
            target = this;
            $(this).data('modal', this);
        }

        if (typeof settings === 'object' || typeof settings === 'undefined') {
            options = $.extend({}, _default, settings);

            $(target).trigger('show.abweb.modal', target);

            if (options.animation === true) {
                viewport.addClass('abweb-modal-open');
            }
            if (options.backdrop === true || options.backdrop === 'static') {
                overlay.show();
                overlay.addClass('overlay-showing');
                if (options.backdrop === true) {
                    closeBackdropAction();
                }
            }
            if (options.keyboard === true) {
                closeKeyboardAction();
            }

            transformModal(target);
            assignCloseActions(target);
        } else if (typeof settings === 'string') {
            $.fn.abwebModal[settings].call(this, params, extra);
        }

        return target;
    };

    $.fn.abwebModal.centre = function()
    {
        if (!$(this).data('modal')) {
            return false;
        }

        var modal = $(this).data('modal');

        var width = $(modal).outerWidth(),
            height = $(modal).outerHeight();

        $(modal).css({
            top: '50%',
            left: '50%',
            marginTop: ((height / 2) * -1) + 'px',
            marginLeft: ((width / 2) * -1) + 'px'
        });

        return true;
    }
    $.fn.abwebModal.center = $.fn.abwebModal.centre;

    $.fn.abwebModal.close = function()
    {
        if (options.backdrop === true || options.backdrop === 'static') {
            overlay.removeClass('overlay-showing');
            animateClass(overlay, 'overlay-hiding', function () { overlay.hide(); });
        }
        if (options.animation === true) {
            viewport.removeClass('abweb-modal-open');
            animateClass(viewport, 'abweb-modal-closing');
        }

        $('.modal-open').trigger('hide.abweb.modal');

        // Remove actions
        overlay.off('click.abwebModal');
        $('body').off('keyup.abwebModal');

        animateClass($('.modal-open'), 'modal-closing', function (element) {
            if ($(element).data('parent')) {
                $(element).removeClass('modal-open');
                $(element).detach();
                $(element).appendTo($(element).data('parent'));
                $(element).hide();
            } else {
                $(element).remove();
            }
        });
    };

    function transformModal(ele)
    {
        var element = $(ele).detach();

        if ($(element).hasClass('hide')) {
            $(element).removeClass('hide');
        }

        // Move the element to the body tag
        $('body').append(element);

        $(element).show();
        var width = $(element).outerWidth(),
            height = $(element).outerHeight();

        $(element).css({
            top: '50%',
            left: '50%',
            marginTop: ((height / 2) * -1) + 'px',
            marginLeft: ((width / 2) * -1) + 'px'
        });

        $(element).addClass('modal-open');
    }

    function animateClass(element, cls, func)
    {
        element.on('webkitTransitionEnd.abwebModal oTransitionEnd.abwebModal transitionend.abwebModal webkitAnimationEnd.abwebModal oAnimationEnd.abwebModal animationend.abwebModal', function (e) {
            element.off('webkitTransitionEnd.abwebModal oTransitionEnd.abwebModal transitionend.abwebModal webkitAnimationEnd.abwebModal oAnimationEnd.abwebModal animationend.abwebModal');
            element.removeClass(cls);
            if (typeof func === 'function') {
                func(element);
            }
        });
        setTimeout(function () {
            element.addClass(cls);
        }, 20);
    }

    function closeBackdropAction()
    {
        overlay.on('click.abwebModal', function () {
            $.fn.abwebModal.close();
        });
    }

    function closeKeyboardAction()
    {
        $('body').on('keyup.abwebModal', function (e) {
            if (e.keyCode === 27) {
                $.fn.abwebModal.close();
            }
        });
    }

    function assignCloseActions(ele)
    {
        $(ele).find('*[data-close-modal]').on('click.abwebModal', function () {
            $.fn.abwebModal.close();
        })
    }

    $.abwebModal = $.fn.abwebModal;

    return true;
})(jQuery);
